import React, { memo, useMemo, useState } from 'react';
import { Badge, Button, Dropdown } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { filterDropDownList, checkUnknown, filterSeedData } from './seedHelper';
import { setFilterIds, setFilteredHistory } from '../../actions/plan';
import { SearchInput } from '../widgets';

const FilterDropDown = ({ seedData, keyName }) => {
	const dispatch = useDispatch();
	const { filterIds } = useSelector(state => state.plan.seedHistory);
	const { payload } = useSelector(state => state.plan.seedHistory);
	const { weightShortName } = useSelector(state => state.user.settings);
	const farmConfig = useSelector(state => state.farm.farmSettings.farm_config);
	const { load_queue: { configuration: { load_queue_params: loadQueueParams } = [] } = {} } = farmConfig || {};

	const [show, setShow] = useState(false);
	const [searchText, setSearchText] = useState('');

	const dropDownList = useMemo(() => filterDropDownList(payload, searchText, keyName, weightShortName, loadQueueParams), [seedData, searchText]);

	const handleApply = () => {
		dispatch(setFilteredHistory((filterSeedData(payload, keyName, filterIds, weightShortName))));
	};

	const handleSelect = (item, name) => {
		let ids = null;
		const index = filterIds[name] ? filterIds[name].indexOf(item.id) : null;

		if (index > -1) ids = filterIds[name] ? filterIds[name].filter((e, i) => i !== index) : null;
		else ids = [...filterIds[name], item.id];

		let obj = { ...filterIds };
		obj[name] = ids;

		dispatch(setFilterIds(obj));
	};

	return (
		<span>
			<Dropdown className="filter-dropdown-container" show={show} onToggle={() => setShow(!show)}>
				<Dropdown.Toggle className="filter-dropdown-toggle">
					<i className="fa fa-filter filter-btn" title="Filter" />
					{filterIds[keyName] && filterIds[keyName].length > 0 && <Badge
						variant="warning"
						className="badge-filter-count">
						{filterIds[keyName].length}
					</Badge>}
				</Dropdown.Toggle>
				<Dropdown.Menu align="right" className="networkStatus" >
					{!(keyName === "approved") && <div className="mx-2 mb-1" >
						<SearchInput
							initialValue={searchText}
							onChange={txt => setSearchText(txt.trim())}
						/>
					</div>}
					<div className={"filter-dropdown-menu-custom"}>
						{dropDownList.hasOwnProperty(keyName) && dropDownList[keyName].map(item => {
							return <div key={item.id} className={`filter-dropdown-item-custom`}>
								<label>
									<span>
										<input
											type="checkbox"
											onChange={(e) => handleSelect(item, keyName)}
											checked={filterIds[keyName] ? filterIds[keyName].includes(item.id) || filterIds[keyName].includes(item.label) : null}
										/>
									</span>
									<span
										className={`item-text ${checkUnknown(String(item.label)) ? 'text-danger' : ''}`}
									>{item.label}</span>
								</label>
							</div>;
						})}
					</div>
					<div className="filter-dropdown-button-custom w-100">
						{dropDownList.length !== 0
							&& <Button variant="success"
								size="sm"
								onClick={() => {
									handleApply();
									setSearchText('');
									setShow(false);
								}}
								className="px-2 mx-2 w-50 filter-apply-button-custom">Apply</Button>}
						{dropDownList.length !== 0
							&& <Button variant="danger"
								size="sm"
								onClick={() => {
									const filterObj = filterIds;
									filterObj[keyName] = [];
									dispatch(setFilterIds(filterObj));
									handleApply();
								}}
								className="px-2 mx-2 w-50">Clear</Button>}
					</div>
					{dropDownList.length === 0 && <div className="text-sm-center my-3 font-weight-normal">No data found</div>}
				</Dropdown.Menu>
			</Dropdown>
		</span>
	);
};

export default memo(FilterDropDown);